module.exports = __webpack_public_path__ + "img/nofound.27ffba24.png";